import ReferencesField from "../Forms/CustomFields/ReferencesField.svelte";
import SelectOptions from '../Forms/SelectOptions.svelte';
import TagEditor from '../Forms/CustomFields/TagEditor.svelte';

export const forms = {
    'report_conclusion': [
        {
            name: 'overall_risk_score',
            label: "Overall Risk Score",
            type: "select",
            choices: {
                static: [
                    {value: "high", label: "High"},
                    {value: "medium", label: "Medium"},
                    {value: "low", label: "Low"},
                ]
            }
        },
        {
            name: 'conclusion',
            label: "Conclusion",
            type: 'textarea',
            dflt: `[Company] has been assigned an overall risk score of High based upon our completed assessment of the enterprise security program.

The assessment identified several critical risks to [Company]’s security posture that put the organization at risk.

A spreadsheet has been provided as a separate document which details the identified risks. This report should be used to develop a risk register and security roadmap to help guide the development of the security program.

Kroll has prioritized the identified risks to help with remediation efforts. These specific recommendations are combined with industry-standard best practices and frameworks. The recommendations that are assigned a risk score of High should be reviewed and addressed immediately to ensure that confidential information is adequately protected.
`,
            preq: {
                field: "overall_risk_score"
            },
            preq_default: {
                high: `[Company] has been assigned an overall risk score of High based upon our completed assessment of the enterprise security program.

The assessment identified several critical risks to [Company]’s security posture that put the organization at risk.

A spreadsheet has been provided as a separate document which details the identified risks. This report should be used to develop a risk register and security roadmap to help guide the development of the security program.

Kroll has prioritized the identified risks to help with remediation efforts. These specific recommendations are combined with industry-standard best practices and frameworks. The recommendations that are assigned a risk score of High should be reviewed and addressed immediately to ensure that confidential information is adequately protected.
`,
                medium: `[Company] has been assigned an overall risk score of Medium based upon our completed assessment of the enterprise security program.

The assessment identified several critical risks to [Company]’s security posture that put the organization at risk.

A spreadsheet has been provided as a separate document which details the identified risks. This report should be used to develop a risk register and security roadmap to help guide the development of the security program.

Kroll has prioritized the identified risks to help with remediation efforts. These specific recommendations are combined with industry-standard best practices and frameworks. The recommendations that are assigned a risk score of High should be reviewed and addressed immediately to ensure that confidential information is adequately protected.
`,
                low: `[Company] has been assigned an overall risk score of Low based upon our completed assessment of the enterprise security program.

The assessment identified several critical risks to [Company]’s security posture that put the organization at risk.

A spreadsheet has been provided as a separate document which details the identified risks. This report should be used to develop a risk register and security roadmap to help guide the development of the security program.

Kroll has prioritized the identified risks to help with remediation efforts. These specific recommendations are combined with industry-standard best practices and frameworks. The recommendations that are assigned a risk score of High should be reviewed and addressed immediately to ensure that confidential information is adequately protected.
`
            }
        }
    ],
    report_overview: [
        {
            name: "client",
            label: "Client Name",
            type: 'text',
            required: true
        },
        {
            name: "short_name",
            label: "Client Short Name",
            type: "text"
        },
        {
            name: "logo_url",
            label: "Client Logo URL",
            type: "text"
        },
        {
            name: "privileged",
            label: "Privileged",
            type: "checkbox"
        },
        {
            name: "start_date",
            label: "Start Date",
            type: "date"
        },
        {
            name: "end_date",
            label: "End Date",
            type: 'date'
        }
    ],
    'assessment': [
        {
            name: "name",
            placeholder: "Assessment Name",
            required: true,
        },
        {
            name: "matter",
            placeholder: "Matter Number",
            required: true
        },
        {
            name: "type",
            type: "select",
            dflt: "CMMC",
            choices: {
                static: [
                    {label: "CMMC", value:"CMMC"}
                ]
            }
        }
    ],

    'assessment_type': [
        {
            label: "Assessment Type Name",
            name: "name",
            placeholder: "Asessment Type Name",
            required: true
        }
    ],

    'category': [
        {
            name: "control_number",
            label: "Control Number",
            placeholder: "e.g. ID",
            required: true
        },
        {
            name: "name",
            label: "Category Name",
            placeholder: "e.g. Identify",
            required: true
        }
    ],

    'subcategory': [
        {
            name: "control_number",
            label: "Control Number",
            placeholder: "e.g. AM",
            required: true
        },
        {
            name: "name",
            label: "Subcategory Name",
            placeholder: "e.g. Asset Managment",
            required: true
        }
    ],

    'control': [
        {
            name: "question_type",
            label: "Answer Type",
            type: "select",
            dflt: "implementation_status_new",
            choices: {
                static: [
                    {label: "Implementation Status", value: "implementation_status_new"},
                    {label: "Yes/No", value: 'yes_no_new'},
                    {label: "Free Text", value: "free_text"}
                ]
            }
        },
        {
            name: 'control_number',
            label: 'Control Number',
            placeholder: 'e.g. 001',
            required: true
        },
        {
            name: "name",
            label: "Control Title",
            required: true
        },
        {
            name: "level",
            label: "Control Level",
            type: "select",
            dflt: "1",
            choices: {
                static: [
                    {label: "Level 1", value: "1"},
                    {label: "Level 2", value: "2"},
                    {label: "Level 3", value: "3"},
                    {label: "Level 4", value: "4"},
                    {label: "Level 5", value: "5"},
                ]
            }
        },
        {
            name: "text",
            label: "Control Text",
            placeholder: "",
            type: "textarea",
            required: true
        },
        {
            name: "guidance",
            label: "Supplemental Guidance",
            type: "tinymce"
        }
    ],

    /*'recommendation': [
        {
            name: "controls",
            label: "Control Reference",
            type: "tags"
        },
        {
            name: "text",
            label: "Recommendation Text",
            type: "textarea",
            required: true
        }
    ],
    */

    'note': [
        {
            name: "note",
            label: "Note",
            type: "textarea",
            required: true
        }
    ],

    'scopeNote': [
        {
            name: "color_class",
            label: "Note Color",
            type: "select",
            dflt: "info",
            choices: {
                static: [
                    {label: "Blue", value: "info"},
                    {label: "Green", value: "success"},
                    {label: "Yellow", value: "warning"},
                    {label: "Red", value: "danger"},
                ]
            }
        },
        {
            name: "note",
            label: "Note",
            type: "text",
            required: true
        }
    ],

    'recommendation': [
        {
            name: 'function',
            label: "Function",
            type: "select",
            dflt: "Identify",
            choices: {
                static: [
                    {value: "Identify"},
                    {value: "Protect"},
                    {value: "Detect"},
                    {value: "Respond"},
                    {value: "Recover"}
                ]
            }
        },
        {
            name: "category",
            label: "Risk Category",
            type: "text",
            required: true
        },
        {
            name: "cis_category",
            label: "CIS category",
            type: "select",
            dflt: "",
            choices: {
                static: [
                    {value: ""},
                    {value: "Inventory of Authorized and Unauthorized Software"},
                    {value: "Secure Configurations for Hardware and Software on Mobile Devices, Laptops, Workstations, and Servers"},
                    {value: "Continuous Vulnerability Assessment and Remediation"},
                    {value: "Controlled Use of Administrative Privileges"},
                    {value: "Maintenance, Monitoring, and Analysis of Audit Logs"},
                    {value: "Email and Web Browser Protections"},
                    {value: "Malware Defenses"},
                    {value: "Limitation and Control of Network Ports, Protocols, and Services"},
                    {value: "Data Recovery Capability"},
                    {value: "Secure Configurations for Network Devices such as Firewalls, Routers, and Switches"},
                    {value: "Boundary Defense"},
                    {value: "Data Protection"},
                    {value: "Controlled Access Based on the Need to Know"},
                    {value: "Wireless Access Control"},
                    {value: "Account Monitoring and Control"},
                    {value: "Security Skills Assessment and Appropriate Training to Fill Gaps"},
                    {value: "Application Software Security"},
                    {value: "Incident Response and Management"},
                    {value: "Penetration Tests and Red Team Exercises"}
                ]
            }
        },
        {
            name: "finding",
            label: "Finding",
            type: 'textarea',
            required: true
        },
        {
            name: "probability",
            label: "Probability",
            type: "select",
            dflt: "High",
            choices: {
                static: [
                    {value: "Low"},
                    {value: "Medium"},
                    {value: "High"},
                ]
            }
        },
        {
            name: "impact",
            label: "Impact",
            type: "select",
            dflt: "High",
            choices: {
                static: [
                    {value: "Low"},
                    {value: "Medium"},
                    {value: "High"},
                ]
            }
        },
        {
            name: "overall",
            label: "Overall Risk Score",
            type: "select",
            dflt: "High",
            choices: {
                static: [
                    {value: "Low"},
                    {value: "Medium"},
                    {value: "High"},
                ]
            }
        },
        {
            name: "recommendation",
            label: "Recommendation",
            type: 'textarea',
            required: true
        },
        {
            name: "references",
            label: "References",
            type: 'custom',
            "component": ReferencesField
        }
    ],

    'positiveControl': [
        {
            name: 'function',
            label: "Function",
            type: "select",
            dflt: "Identify",
            choices: {
                static: [
                    {value: "Identify"},
                    {value: "Protect"},
                    {value: "Detect"},
                    {value: "Respond"},
                    {value: "Recover"}
                ]
            }
        },
        {
            name: "title",
            label: "Title",
            type: "text",
            required: true
        },
        {
            name: "text",
            label: "Control Text",
            type: 'textarea',
            required: true
        },
    ],

    'keyRecommendation':  [
        {
            label: "Key Recommendation",
            name: "text",
            type: "textarea",
        }
    ],
    'serviceRecommendation': [
        {
            name: "color",
            label: "Shield Color",
            type: "select",
            dflt: "Gray",
            choices: {
                static: [
                    {value: "Gray"},
                    {value: "Blue"},
                    {value: "Purple"},
                    {value: "Orange"}
                ]
            }
        },
        {
            name: "title",
            label: "Title",
            type: "text",
            required: true
        },
        {
            name: "description",
            label: "Service Description",
            type: "textarea",
            required: true
        }
    ],
    'policy': [
        {
            name: "name",
            label: "Policy Name",
        },
        {
            name: "recommendation",
            label: "Policy Recommendation",
            type: "textarea"
        },
        {
            name: "references",
            label: "Policy References",
            type: "tags"
        }
    ],
    'threat': [
        {
            name: "name",
            label: "Threat Name",
            required: true
        }
    ],
    'threatControl': [
        {
            name: "name",
            label: "Control Name",
            required: true
        }
    ],
    'library': [
        {
            name: "name",
            label: "Library Name",
            required: true
        }
    ],
    'dashboard': [
        {
            name: "name",
            label: "Dashboard Name",
            required: true
        }
    ],

    'SVG': [
        {
            name: "name",
            label: "Name",
            type: "text",
            required: true
        },
        {
            name: "svg",
            label: "Image",
            type: 'textarea',
            required: true
        },
    ],

    'reportGraphic': [
        {
            name: "name",
            label: "Name",
            type: "text",
            required: true
        },
        {
            name: "height",
            label: "Height (px)",
            type: "number",
            required: true
        },
        {
            name: "width",
            label: "Width (px)",
            type: "number",
            required: true
        },
    ],

    'customForm': [
        {
            name: "name",
            label: "Field Name",
            type: "text",
            required: true
        },
        {
            name: 'type',
            label: "Field Type",
            type: "select",
            required: true,
            choices: {
                static: [
                    {label: "Text", value: "text"},
                    {label: "Select", value: "select"},
                    {label: "Checkbox", value: "checkbox"},
                    {label: "Text Area", value: "textarea"},
                    {label: "Password", value: "password"},
                    {label: "Email", value: "email"},
                    {label: "Telephone", value: "tel"},
                    {label: "Date", value: "date"},
                    {label: "Tags", value: "tags"},
                    {label: "Custom Tags", value: "customTags"},
                    {label: "Risk Select", value: "risk"},
                    {label: "References", value: "references"},
                    {label: "Reference Library", value: "referenceLibrary"}
                ]
            }
        },
        {
            name: "required",
            label: "Required",
            dflt: false,
            type: 'checkbox'
        },
        {
            name: "default_hidden",
            label: "Hide by Default",
            dflt: false,
            type: "checkbox"
        },
        {
            name: "options",
            dflt: [],
            type: 'custom',
            "component": SelectOptions,
            preq: {
                field: "type",
                value: "select"
            }
        },
        {
            name: "options",
            label: "Tags",
            dflt: [],
            type: 'custom',
            "component": TagEditor,
            preq: {
                field: "type",
                value: "customTags"
            }
        },
        {
            name: "dflt",
            type: 'text',
            label: "Default",
            preq: {
                field: 'type',
                value: 'text'
            }
        },
        {
            name: "dflt",
            type: 'textarea',
            label: "Default",
            preq: {
                field: 'type',
                value: 'textarea'
            }
        }
    ],

    'dashboardItem': [
        {
            name: "name",
            label: "Field Name",
            type: "text",
            required: true
        },
        {
            name: 'type',
            label: "Field Type",
            type: "select",
            choices: {
                static: [
                    {label: "Text", value: "text"},
                    {label: "Select", value: "select"},
                    {label: "Checkbox", value: "checkbox"},
                    {label: "Text Area", value: "textarea"},
                    {label: "Password", value: "password"},
                    {label: "Email", value: "email"},
                    {label: "Telephone", value: "tel"},
                    {label: "Date", value: "date"},
                    {label: "Tags", value: "tags"}
                ]
            }
        },
        {
            name: "required",
            label: "Required",
            dflt: false,
            type: 'checkbox'
        },
        {
            name: "show_in_table",
            label: "Show in Table",
            dflt: true,
            type: "checkbox"
        },
        {
            name: "options",
            dflt: [],
            type: 'custom',
            "component": SelectOptions,
            preq: {
                field: "type",
                value: "select"
            }
        }
    ]
};